export default __webpack_public_path__ + "static/media/sipmenu-feedback.95eb7b64.svg";